/* eslint-disable react/jsx-props-no-spreading */
import React, { useMemo } from 'react';
import { Field } from 'react-final-form';

import { isEmpty } from 'utils/lodash';

import SelectComponent from './SelectComponent';
import { PTField } from '../propTypes';

/**
 * @type {React.FC<any>}
 */
const Select = (props) => {
  const { validate, required } = props;

  const validateField = useMemo(() => {
    if (required && isEmpty(validate)) {
      return (value) => isEmpty(value) && 'Обязательное поле';
    }

    return validate;
  }, [validate, required]);

  return <Field {...props} validate={validateField} component={SelectComponent} />;
};

Select.propTypes = {
  ...SelectComponent.propTypes,
  ...PTField,
};

export default Select;
